import React from 'react';
import './AuthorNameDecoration.css';

/**
 * Yazar adı yanında minimal mutfak vurgusu (site turuncusu, küçük ikon).
 */
export default function AuthorNameDecoration({ variant = 'card' }) {
  return (
    <span
      className={`author-name-decoration author-name-decoration--${variant}`}
      aria-hidden="true"
    >
      <i className="fa-solid fa-utensils" />
    </span>
  );
}
